import { createContext } from 'react';

import { LanguagesKeys } from "../header/header-context";

export const LanguageContextDefaultValue = Object.freeze(LanguagesKeys.en);
const LanguageContext = createContext<string>(LanguageContextDefaultValue);

export default LanguageContext;

